import {
  DashboardStats,
  LicitacionesPorEstado,
  LicitacionesPorMes,
  TasaExitoHistorica,
  DeadlineItem,
  AIUsageStats,
} from "@/types/analytics";
import { fetchWithAuth } from "./client";

export const analyticsApi = {
  getDashboardStats: async (): Promise<DashboardStats> => {
    return fetchWithAuth("/api/v1/analytics/dashboard");
  },

  getLicitacionesPorEstado: async (): Promise<LicitacionesPorEstado[]> => {
    return fetchWithAuth("/api/v1/analytics/licitaciones/estado");
  },

  getLicitacionesPorMes: async (year: number): Promise<LicitacionesPorMes[]> => {
    return fetchWithAuth(`/api/v1/analytics/licitaciones/mes?year=${year}`);
  },

  getTasaExitoHistorica: async (months: number = 12): Promise<TasaExitoHistorica[]> => {
    return fetchWithAuth(`/api/v1/analytics/tasa-exito?months=${months}`);
  },

  getUpcomingDeadlines: async (days: number = 30): Promise<DeadlineItem[]> => {
    return fetchWithAuth(`/api/v1/analytics/deadlines?days=${days}`);
  },

  getAIUsageStats: async (): Promise<AIUsageStats> => {
    return fetchWithAuth("/api/v1/analytics/ai-usage");
  },
};
